export type TypeEnv = "dev" | "re7" | "preprod" | "prod"

// TODO: Parametrer l'environnement depuis le serveur
const ENV: TypeEnv = global.ENV || "dev"

type IEnvConfig = {|
  WS_PREFIX: string,
  logLevel: "debug" | "info" | "warn" | "error",
  visioglobe: {
    mapHash: string
  }
|}

type ICommonConfig = {|
  theme: {|
    colors: {
      main: string,
      white: string,
      tabSelected: string,
      background: string,
      twitter: string,
      available: string,
      mixed: string,
      noInformation: string,
      busy: string,
      occupancyBackgroundContent: string,
      occupancyStatusBarBackground: string
    }
  |},
  webservices: {|
    poi: {|
      status: string
    |},
    restaurant: {|
      attendance: string
    |}
  |}
|}

const CommonConfig: ICommonConfig = {
  theme: {
    colors: {
      main: "#006a4d",
      white: "#ffffff",
      tabSelected: "#69be28",
      background: "#ebebeb",
      twitter: "#00aced",
      available: "#69be28",
      mixed: "#ffa500",
      noInformation: "#000000",
      busy: "#ff0000",
      occupancyBackgroundContent: "#f8f9fa",
      occupancyStatusBarBackground: "#E4E4E4"
    }
  },
  webservices: {
    poi: {
      status: "/contrib/poi/v1/occupancy"
    },
    restaurant: {
      attendance: "/v1/restaurant"
    }
  }
}

const EnvConfig = ((): IEnvConfig => {
  switch (ENV) {
    case "dev":
      return {
        WS_PREFIX: "http://localhost:8080/services",
        logLevel: "debug",
        visioglobe: {
          mapHash: "dev-k00489e35187f26fb865c38705f899db1b116deaf"
        }
      }
    case "re7":
      return {
        WS_PREFIX: "/services",
        logLevel: "info",
        visioglobe: {
          mapHash: "dev-kbc407153f22fea30d7ee6ceaf680ba40ecc3ec16"
        }
      }
    case "preprod":
      return {
        WS_PREFIX: "/services",
        logLevel: "warn",
        visioglobe: {
          mapHash: "k0e462b8324aa084bc51f49e141bc76fde168989f"
        }
      }
    case "prod":
      return {
        WS_PREFIX: "/services",
        logLevel: "warn",
        visioglobe: {
          mapHash: "k5247841da9fa74a669a3cd7426e49a27b3f603ba"
        }
      }
    default: {
      throw Error("Unknown env : " + ENV)
    }
  }
})()

const config: IConfig = {
  ENV,
  ...CommonConfig,
  ...EnvConfig
}
export default config



// WEBPACK FOOTER //
// ./src/config.js